<template>
  <div class="MyRecord MobileNoCollapse">
    <div class="PageCommon">
      <div class="bscroll" ref="bscroll">
        <div class="bscroll-container">
          <h3 class="pageTitle" v-if="!mobileFlag">
            {{ $t("Menu_History") }}
          </h3>
          <div class="mobileFilterDiv" v-if="mobileFlag">
            <el-button
              class="mobileFilterBtn"
              @click="mobileSearchDrawer = true"
              type="text"
              size="small"
            >
              {{ $t("Common_Operation_Filter") }}
              <svg-icon
                class="greenIcon"
                icon-class="MobileFilterBtn"
              ></svg-icon>
            </el-button>
          </div>

          <div class="tableSearch" v-if="!mobileFlag">
            <el-form
              label-position="top"
              :model="tableSearchForm"
              ref="tableSearchForm"
            >
              <el-form-item
                :label="$t('Common_TableTitle_Mt4Account')"
                prop="Account"
              >
                <el-input v-model="tableSearchForm.Account"></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('Common_TableTitle_OperationTime')"
                prop="DateRange"
              >
                <el-date-picker
                  v-model="tableSearchForm.DateRange"
                  type="daterange"
                  range-separator="—"
                  value-format="yyyy-MM-dd"
                  :start-placeholder="$t('Common_ChooseStartTime')"
                  :end-placeholder="$t('Common_ChooseEndTime')"
                >
                </el-date-picker>
                <svg-icon class="dateIcon" icon-class="TimeIcon"></svg-icon>
              </el-form-item>
              <el-form-item class="noLabel">
                <el-button class="serchFormBtn" @click="getData(1, pageSize)">
                  {{ $t("Common_Search") }}
                  <svg-icon icon-class="SearchIcon"></svg-icon>
                </el-button>
              </el-form-item>
              <el-form-item class="noLabel">
                <el-button class="resetFormBtn" @click="reset()">
                  {{ $t("Common_Reset") }}
                  <svg-icon icon-class="ResetIcon"></svg-icon>
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="tableDiv" v-if="!mobileFlag">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column
                width="80"
                v-if="!mobileFlag"
                :fixed="tableData.length !== 0 ? true : false"
                prop="sortNum"
                :label="$t('Common_TableTitle_Number')"
              >
              </el-table-column>
              <el-table-column
                :fixed="tableData.length !== 0 ? true : false"
                width="120"
                prop="account"
                :label="$t('Common_TableTitle_Mt4Account')"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.account>0">
                   {{scope.row.mtType}}.{{ scope.row.account }}
                  </div>
                  <div v-if="scope.row.account<=0">
                    -
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="portfolioName"
                width="150"
                :label="$t('Common_TableTitle_SignalSource')"
              >
              </el-table-column>
              <el-table-column
                prop="actionTime"
                width="180"
                :label="$t('Common_TableTitle_OperationTime')"
              >
              </el-table-column>
              <el-table-column
                prop="description"
                :width="mobileFlag ? '280' : 'auto'"
                :label="$t('Common_TableTitle_Details')"
              >
              </el-table-column>
              <el-table-column
                width="120"
                :label="$t('Common_TableTitle_Result')"
              >
                <template slot-scope="scope">
                  <div>
                    <el-result
                      v-if="scope.row.result"
                      icon="success"
                    ></el-result>
                    <el-result
                      v-if="!scope.row.result"
                      icon="error"
                    ></el-result>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              class="tablePage"
              :prev-text="$t('Common_PreviousPage')"
              :pager-count="5"
              :next-text="$t('Common_NexPage')"
              :current-page="currentPage"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :page-sizes="[5, 10, 20, 50, 100]"
              :page-size="pageSize"
              layout="prev, pager, next, sizes"
              :total="total"
            >
            </el-pagination>
          </div>
          <div class="mobileTableList" v-show="mobileFlag">
            <el-collapse accordion>
              <el-collapse-item v-for="(item, index) in tableData" :key="index">
                <template slot="title">
                  <div class="mobileTableCard" @click.stop="showCollapse()">
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_Mt4Account") }}
                      </p>
                      <p class="mobileTableContent" v-if="item.account>0">
                        {{ item.mtType }}.{{ item.account }}
                      </p>
                      <p class="mobileTableContent" v-if="item.account<=0">
                       -
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_SignalSource") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.portfolioName }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_OperationTime") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.actionTime }}
                      </p>
                    </div>
                    <div class="mobileTableItem">
                      <p class="mobileTableTitle">
                        {{ $t("Common_TableTitle_Result") }}
                      </p>
                      <p class="mobileTableContent">
                        <el-result
                          v-if="item.result"
                          icon="success"
                        ></el-result>
                        <el-result v-if="!item.result" icon="error"></el-result>
                      </p>
                    </div>
                    <div class="mobileTableItem mobileTableStatusTitle">
                      <p class="mobileTableTitle mo">
                        {{ $t("Common_TableTitle_Details") }}
                      </p>
                      <p class="mobileTableContent">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </template>
              </el-collapse-item>
            </el-collapse>
            <div class="x" v-if="up && tableData.length < total">
              <i class="el-icon-loading"></i>
              {{ $t("Common_Loading") }}
            </div>
            <div class="x" v-if="!up && tableData.length >= total">
              {{ $t("Common_NoMoreData") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      class="mobileSearchDrawer"
      :visible.sync="mobileSearchDrawer"
      direction="ttb"
    >
      <div class="mobileFilterReturnBtnDiv">
        <el-button
          class="mobileFilterReturnBtn"
          @click="mobileSearchDrawer = false"
        >
          {{ $t("Common_Search") }}
          <i class="el-icon-arrow-up"></i>
        </el-button>
      </div>

      <el-form
        label-position="top"
        :model="tableSearchForm"
        ref="tableSearchForm"
      >
        <el-form-item
          :label="$t('Common_TableTitle_Mt4Account')"
          prop="Account"
        >
          <el-input v-model="tableSearchForm.Account"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Common_TableTitle_OperationTime')"
          prop="DateRange"
        >
          <el-date-picker
            v-model="tableSearchForm.DateRange"
            type="daterange"
            range-separator="—"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('Common_ChooseStartTime')"
            :end-placeholder="$t('Common_ChooseEndTime')"
          >
          </el-date-picker>
          <svg-icon class="dateIcon" icon-class="TimeIcon"></svg-icon>
        </el-form-item>
      </el-form>
      <div class="mobileFilterBottomBtns">
        <el-button class="resetFormBtn" @click="reset()">
          {{ $t("Common_Reset") }}
        </el-button>
        <el-button class="serchFormBtn" @click="getData(1, pageSize)">
          {{ $t("Common_Search") }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  concatParams,
  concatTableData,
  dateGmt8,
} from "../../plugins/common.js";
import { mapState } from "vuex";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";

BScroll.use(Pullup);

export default {
  name: "MyRecord",
  components: {},
  computed: {
    ...mapState(["checkPortfolio", "mobileFlag"]),
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 5,
      tableSearchForm: {
        Account: "",
        DateRange: [],
      },
      mobileSearchDrawer: false,
      up: false,
    };
  },
  created() {
     this.getData(this.currentPage, this.pageSize);
  },
  methods: {
    scrollFn() {
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.bscroll, {
            click: true,
            scrollY: true,
            probeType: 3,
          });
        } else {
          this.scroll.refresh();
        }

        //touchEnd（手指离开以后触发） 通过这个方法来监听下拉刷新
        this.scroll.on("touchEnd", (pos) => {
          //上拉加载 总高度>下拉的高度+10 触发加载更多
          if (this.scroll.maxScrollY > pos.y + 50) {
            // console.log("加载更多")
            this.up = true;
            setTimeout(() => {
              //使用refresh 方法 来更新scroll  解决无法滚动的问题
              if (this.tableData.length < this.total) {
                this.currentPage = this.currentPage + 1;
                this.getData(this.currentPage, this.pageSize, "noRefresh");
                this.scroll.refresh();
                this.up = false;
              } else {
                this.up = false;
              }
            }, 1000);
          }
          // console.log(this.scroll.maxScrollY+"总距离----下拉的距离"+pos.y)
        });

        // console.log(this.scroll.maxScrollY)
      });
    },
    getData(pageIndex, pageSize, tag) {
      const loading = this.$loading({
        lock: true,
      });
      if (!this.mobileFlag || tag !== "noRefresh") {
        this.tableData = [];
      }
       console.log(this.tableSearchForm.length)
      var params = {
        Account: this.tableSearchForm.Account.trim(),
        DateRange:
          this.tableSearchForm.DateRange.length !== 0
            ? this.tableSearchForm.DateRange[0] +
              "~" +
              this.tableSearchForm.DateRange[1]
            : "",
        pageIndex: pageIndex,
        pageSize: pageSize,
      };
      this.$axios
        .get("/Api/ActionHistory/Get" + concatParams(params))
        .then((res) => {
          let dt = res.data;
          if (dt.isSuccess) {
            this.total = dt.result.total;
            // this.tableData = concatTableData(dt.result.pageList, dt.result.total, dt.result.pageIndex, this.pageSize)
            if (this.mobileFlag && tag == "noRefresh") {
              dt.result.pageList.forEach((item) => {
                this.tableData.push(item);
              });
            } else {
              this.tableData = concatTableData(
                dt.result.pageList,
                dt.result.total,
                this.currentPage,
                this.pageSize
              );
            }

            this.fullscreenLoading = false;
            if (this.mobileFlag) {
              this.scrollFn();
            }
          }
        })
        .finally(() => {
          this.mobileSearchDrawer = false;
           loading.close();
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.currentPage, this.pageSize);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData(this.currentPage, this.pageSize);
    },
    reset() {
      this.$refs.tableSearchForm.resetFields();
       this.currentPage = 1;
      this.getData(this.currentPage, this.pageSize);
    },
    refresh() {
      window.location.reload();
    },
  },
};
</script>
<style lang="less" scoped>
.refreshListBtnDiv {
  position: absolute;
  right: 60px;
  top: 135px;
}
@media screen and (max-width: 1685px) {
  .refreshListBtnDiv {
    top: 140px;
  }
}
@media screen and (max-width: 1445px) {
  .refreshListBtnDiv {
    top: 148px;
  }
}
@media screen and (max-width: 1285px) {
  .refreshListBtnDiv {
    top: 160px;
  }
}
@media screen and (max-width: 1025px) {
  .refreshListBtnDiv {
    top: 40px;
  }
}
@media screen and (max-width: 767px) {
  .followAccount {
    .pageTitleBtn {
      margin: 20px 0 0 0;
    }
  }

  .home {
    .content {
      .tableSearch {
        .el-form {
          .el-form-item {
            width: 90%;
          }

          .el-date-editor--daterange.el-input__inner {
            width: 100%;
          }

          .noLabel {
            width: 48%;
          }
        }
      }
    }
  }
  .refreshListBtnDiv {
    position: absolute;
    right: 20px;
    top: 5px;
    .confirmDialogBtn {
      padding: 10px;
      font-size: 12px;
      line-height: 15px;
    }
  }
}
</style>
